import React from "react";
import { AiOutlineExclamation } from "react-icons/ai";
import { MdCheck, MdClose } from "react-icons/md";
import { toast as _toast, ToastOptions, Slide, TypeOptions } from "react-toastify";

import "./toast.css";

export const defaultOptions: ToastOptions = {
  position: "bottom-right",
  autoClose: 5000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  transition: Slide,
};

export const ToastLayout = ({ text }: { text: string }) => {
  return (
    <div className="bg-base-white">
      <p className="text-base-black">{text}</p>
    </div>
  );
};

const CloseButton: React.FC<{ closeToast?: () => void }> = ({ closeToast }) => (
  <button onClick={closeToast} className="cursor-pointer">
    <MdClose size="1.5rem" className="mx-2 min-w-3 self-center text-base-black opacity-50" />
  </button>
);

type Args = [string, Partial<ToastOptions>?];

const toastIcon = {
  success: <MdCheck size="1.5rem" className="text-base-white" />,
  error: <AiOutlineExclamation size="1.5rem" className="text-base-white" />,
  info: undefined,
  warning: undefined,
  default: undefined,
};

function parse(type: TypeOptions, text: string, options: Partial<ToastOptions> = {}) {
  return _toast(<ToastLayout text={text} />, {
    ...defaultOptions,
    ...options,
    type,
    icon: toastIcon[type],
    closeButton: <CloseButton />,
  });
}

export const toast = {
  success: (...args: Args) => parse("success", ...args),
  error: (...args: Args) => parse("error", ...args),
  info: (...args: Args) => parse("info", ...args),
  default: (...args: Args) => parse("info", ...args),
};
